var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Red (High), SIze=16, Type=Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1258 11.5195L10.5442 1.70196C10.0855 0.940952 9.29268 0.480469 8.44108 0.480469C7.58947 0.480469 6.79663 0.940952 6.33796 1.70196L0.756344 11.5195C0.35504 12.2289 0.341169 13.1116 0.719958 13.8349C1.15803 14.6493 1.97544 15.1506 2.85946 15.147H14.0227C14.9007 15.1569 15.7167 14.6683 16.1622 13.8658C16.5523 13.1346 16.5384 12.2366 16.1258 11.5195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1258 11.5195L10.5442 1.70196C10.0855 0.940952 9.29268 0.480469 8.44108 0.480469C7.58947 0.480469 6.79663 0.940952 6.33796 1.70196L0.756344 11.5195C0.35504 12.2289 0.341169 13.1116 0.719958 13.8349C1.15803 14.6493 1.97544 15.1506 2.85946 15.147H14.0227C14.9007 15.1569 15.7167 14.6683 16.1622 13.8658C16.5523 13.1346 16.5384 12.2366 16.1258 11.5195ZM8.44108 12.0597C8.03917 12.0597 7.71336 11.7142 7.71336 11.2879C7.71336 10.8616 8.03917 10.5161 8.44108 10.5161C8.84299 10.5161 9.1688 10.8616 9.1688 11.2879C9.1688 11.7142 8.84299 12.0597 8.44108 12.0597ZM8.44108 9.74428C8.84299 9.74428 9.1688 9.39873 9.1688 8.97246V5.8852C9.1688 5.45894 8.84299 5.11339 8.44108 5.11339C8.03917 5.11339 7.71336 5.45894 7.71336 5.8852V8.97246C7.71336 9.39873 8.03917 9.74428 8.44108 9.74428Z",
    fill: "#F00707"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtRisk);
export default __webpack_public_path__ + "static/media/at_risk.4682e6bc2c858f6f91a5d9ff65457109.svg";
export { ForwardRef as ReactComponent };